import { render, staticRenderFns } from "./SubRoute.vue?vue&type=template&id=184a269a&"
import script from "./SubRoute.vue?vue&type=script&lang=js&"
export * from "./SubRoute.vue?vue&type=script&lang=js&"
import style0 from "./SubRoute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SubRoute.vue"
export default component.exports